import callApi from 'src/api';

export const fetchRepairManagementCall = (repMgmt: number) => {
    const endpoint = `/api/repairManagement/repMgmt/${repMgmt}`;
    return callApi(endpoint);
};
